

import { CreateBankDetailsActionTypes, DeleteBankDetailsActionTypes, GetBankDetailsActionTypes, EditBankDetailsActionTypes } from '../actionsTypes';

const initialState = {
    createbankdetails: {},
    deletebankdetails: [],
    getbankdetails: [],
    editbankdetails: {},
    error: '',
    isCreatingEmployees: false,
};

const BankDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case CreateBankDetailsActionTypes.SUCCESS:
            return {
                ...state,
                isCreatingEmployees: false,
                createbankdetails: action.payload,
            };
        // case CreateBankDetailsActionTypes.FAILED:
        //     return {
        //         ...state,
        //         isCreatingEmployees: false,
        //         error: action.error,
        //     };
        // Deleting
        case DeleteBankDetailsActionTypes.SUCCESS:
            return action.payload;

        // Getting values
        case GetBankDetailsActionTypes.SUCCESS:
            return {
                ...state,
                getbankdetails: action.payload,
            };
        // Editing values
        case EditBankDetailsActionTypes.SUCCESS:
            return {
                ...state,
                editbankdetails: action.payload,
            };
        default:
            return state;
    }
};

export default BankDetailsReducer;